import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter: React.FC = () => {
  return (
    <footer className="py-6 text-center text-xs text-slate-400 dark:text-textQuaternary-dark">
      <div className="mb-2">
        © {new Date().getFullYear()} Culinary Cloud. All rights reserved.
      </div>
      <div className="flex justify-center space-x-3 mt-2 text-[11px]">
        <Link
          to="/terms-and-conditions"
          className="text-slate-400 hover:text-slate-300 dark:text-textQuaternary-dark dark:hover:text-textTertiary-dark transition underline"
        >
          T&C
        </Link>
        <Link
          to="/culinary-cloud-privacy-policy"
          className="text-slate-400 hover:text-slate-300 dark:text-textQuaternary-dark dark:hover:text-textTertiary-dark transition underline"
        >
          Privacy
        </Link>
        <Link
          to="/cookies-policy"
          className="text-slate-400 hover:text-slate-300 dark:text-textQuaternary-dark dark:hover:text-textTertiary-dark transition underline"
        >
          Cookies
        </Link>
      </div>
    </footer>
  );
};

export default AppFooter;
